import { label, selectControl } from "../UI/tokens";
import { Form } from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import styled from "styled-components";

export const LabelInput = styled(Form.Label)`
${label}
`;

export const DivInput = styled.div`
    border-radius: 0px 0px 5px 0px;
`;

export const DivFormGroup = styled(Form.Group)`
    margin-bottom: 1px;

margin-bottom: 14px; min-width: 0;
`;



export const DinamicSelect = styled(AsyncSelect).attrs(() => ({
  styles: {
    menuPortal: base => ({ ...base, zIndex: 9999 })  // Define um z-index alto para o menu
  },
  menuPortalTarget: document.body,  // Anexa o dropdown ao body
}))`
	[class*="control"] {
		border-radius: 0px 5px 5px 0px;
		max-width: 100%;
		flex-grow: 1;
		font-size: 14px; // You need to provide a unit for font-size, e.g., 'px'
	}

	[class*="singleValue"] {
		color: black;
	}

${selectControl}
`;